import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Api from "../../utils/api";
export function getCustomer(_x) {
  return _getCustomer.apply(this, arguments);
}
function _getCustomer() {
  _getCustomer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var state, commit, _yield$Api$get, data;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          state = _ref.state, commit = _ref.commit;
          if (!state.customer) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", state.customer);
        case 1:
          _context.next = 2;
          return Api().get('api/customer');
        case 2:
          _yield$Api$get = _context.sent;
          data = _yield$Api$get.data;
          commit('customer/setCustomer', data, {
            root: true
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getCustomer.apply(this, arguments);
}
export function setDefaultEmail(_x2, _x3) {
  return _setDefaultEmail.apply(this, arguments);
}
function _setDefaultEmail() {
  _setDefaultEmail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, email) {
    var state, commit;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          state = _ref2.state, commit = _ref2.commit;
          commit('customer/setDefaultEmail', email.id(), {
            root: true
          });
          _context2.next = 1;
          return Api().post("api/default-email/".concat(email.id()), {
            email: email.get('address')
          });
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _setDefaultEmail.apply(this, arguments);
}
export function setDefaultPhone(_x4, _x5) {
  return _setDefaultPhone.apply(this, arguments);
}
function _setDefaultPhone() {
  _setDefaultPhone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, phoneId) {
    var state, commit;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          state = _ref3.state, commit = _ref3.commit;
          commit('customer/setDefaultPhone', phoneId, {
            root: true
          });
          _context3.next = 1;
          return Api().post("api/default-phone/".concat(phoneId));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _setDefaultPhone.apply(this, arguments);
}
export function addEmail(_x6, _x7) {
  return _addEmail.apply(this, arguments);
}
function _addEmail() {
  _addEmail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, params) {
    var state, commit, p, _yield$Api$post, data;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          state = _ref4.state, commit = _ref4.commit;
          p = JSON.parse(JSON.stringify(params));
          p.type = params.type.value;
          _context4.next = 1;
          return Api().post("api/add-email", p);
        case 1:
          _yield$Api$post = _context4.sent;
          data = _yield$Api$post.data;
          commit('customer/addEmail', data, {
            root: true
          });
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _addEmail.apply(this, arguments);
}
export function sendVerificationEmail(_x8, _x9) {
  return _sendVerificationEmail.apply(this, arguments);
}
function _sendVerificationEmail() {
  _sendVerificationEmail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5, address) {
    var state;
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          state = _ref5.state;
          _context5.next = 1;
          return Api().post('api/send-email-verification', {
            email: address
          });
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _sendVerificationEmail.apply(this, arguments);
}
export function addPhone(_x0, _x1) {
  return _addPhone.apply(this, arguments);
}
function _addPhone() {
  _addPhone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref6, params) {
    var state, commit, p, _yield$Api$post2, data;
    return _regeneratorRuntime.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          state = _ref6.state, commit = _ref6.commit;
          p = JSON.parse(JSON.stringify(params));
          p.type = params.type.value;
          p.phone = p.phone.replace('+', '');
          _context6.next = 1;
          return Api().post("api/add-phone", p);
        case 1:
          _yield$Api$post2 = _context6.sent;
          data = _yield$Api$post2.data;
          commit('customer/addPhone', data, {
            root: true
          });
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _addPhone.apply(this, arguments);
}
export function sendMobileVerification(_x10, _x11) {
  return _sendMobileVerification.apply(this, arguments);
}
function _sendMobileVerification() {
  _sendMobileVerification = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref7, phone) {
    var state;
    return _regeneratorRuntime.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          state = _ref7.state;
          _context7.next = 1;
          return Api().post('api/send-mobile-verification/' + phone.id());
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _sendMobileVerification.apply(this, arguments);
}
export function sendPrimaryMobileVerification(_x12) {
  return _sendPrimaryMobileVerification.apply(this, arguments);
}
function _sendPrimaryMobileVerification() {
  _sendPrimaryMobileVerification = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref8) {
    var state;
    return _regeneratorRuntime.wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          state = _ref8.state;
          _context8.next = 1;
          return Api().post('api/send-primary-mobile-verification');
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _sendPrimaryMobileVerification.apply(this, arguments);
}
export function verifyMobile(_x13, _x14) {
  return _verifyMobile.apply(this, arguments);
}
function _verifyMobile() {
  _verifyMobile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref9, params) {
    var state;
    return _regeneratorRuntime.wrap(function (_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          state = _ref9.state;
          _context9.next = 1;
          return Api().post('api/verify-mobile/' + params.phone.id(), {
            code: params.code
          });
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _verifyMobile.apply(this, arguments);
}
export function verifyPrimaryMobile(_x15, _x16) {
  return _verifyPrimaryMobile.apply(this, arguments);
}

// export async function deleteEmail ({ state, commit }, emailId) {
//   await Api().delete(`api/email/${emailId}`)
//
//   commit('customer/deleteEmail', emailId, {
//     root: true
//   })
// }

// export async function deletePhone ({ state, commit }, phoneId) {
//   await Api().delete(`api/phone/${phoneId}`)
//
//   commit('customer/deletePhone', phoneId, {
//     root: true
//   })
// }
function _verifyPrimaryMobile() {
  _verifyPrimaryMobile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(_ref0, params) {
    var state, _yield$Api$post3, data;
    return _regeneratorRuntime.wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          state = _ref0.state;
          _context0.next = 1;
          return Api().post('api/verify-primary-mobile', {
            code: params.code
          });
        case 1:
          _yield$Api$post3 = _context0.sent;
          data = _yield$Api$post3.data;
          return _context0.abrupt("return", data);
        case 2:
        case "end":
          return _context0.stop();
      }
    }, _callee0);
  }));
  return _verifyPrimaryMobile.apply(this, arguments);
}
export function requestCallback(_x17, _x18) {
  return _requestCallback.apply(this, arguments);
}
function _requestCallback() {
  _requestCallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1(_ref1, params) {
    var state;
    return _regeneratorRuntime.wrap(function (_context1) {
      while (1) switch (_context1.prev = _context1.next) {
        case 0:
          state = _ref1.state;
          _context1.next = 1;
          return Api().post("api/callback", {
            params: params
          });
        case 1:
        case "end":
          return _context1.stop();
      }
    }, _callee1);
  }));
  return _requestCallback.apply(this, arguments);
}
export function searchAddressByPostcode(_x19, _x20) {
  return _searchAddressByPostcode.apply(this, arguments);
}
function _searchAddressByPostcode() {
  _searchAddressByPostcode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref10, params) {
    var state, _yield$Api$get2, data;
    return _regeneratorRuntime.wrap(function (_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          state = _ref10.state;
          _context10.next = 1;
          return Api().get("api/search-address", {
            params: params
          });
        case 1:
          _yield$Api$get2 = _context10.sent;
          data = _yield$Api$get2.data;
          return _context10.abrupt("return", data);
        case 2:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _searchAddressByPostcode.apply(this, arguments);
}
export function updateCurrentAddress(_x21, _x22) {
  return _updateCurrentAddress.apply(this, arguments);
}
function _updateCurrentAddress() {
  _updateCurrentAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref11, params) {
    var state, commit, _yield$Api$post4, data;
    return _regeneratorRuntime.wrap(function (_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          state = _ref11.state, commit = _ref11.commit;
          _context11.next = 1;
          return Api().post("api/update-address", params);
        case 1:
          _yield$Api$post4 = _context11.sent;
          data = _yield$Api$post4.data;
          commit('customer/updateAddress', data, {
            root: true
          });
          return _context11.abrupt("return", data);
        case 2:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _updateCurrentAddress.apply(this, arguments);
}
export function sendSar(_x23) {
  return _sendSar.apply(this, arguments);
}
function _sendSar() {
  _sendSar = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref12) {
    var state, _yield$Api$post5, data;
    return _regeneratorRuntime.wrap(function (_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          state = _ref12.state;
          _context12.next = 1;
          return Api().post('api/send-sar');
        case 1:
          _yield$Api$post5 = _context12.sent;
          data = _yield$Api$post5.data;
          return _context12.abrupt("return", data);
        case 2:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _sendSar.apply(this, arguments);
}